export class QuickLinks {

    title: string = "";
    links: string[] = [];

     constructor(title: string, links: string[]){
        this.title = title;
        this.links = links;
     }
 }